export default {
  props: {
    logo: {
      type: Object,
    },

    title: {
      type: String,
    },

    background: {
      type: Object,
    },
  },
}
